// src/router/index.ts
// Issue #29：改為「純 routes 陣列」匯出，不在此建立 router 實例。
// WHY：vite-ssg 需 self-provided router（client 用 createWebHistory、SSG 用 memory history）；
//      若在 module 頂層 createRouter，SSG 的 Node 環境沒有 DOM 會炸。
//      title/description/og/canonical 統一交由 src/ssg/seo.ts（App.vue）依 route.meta 產生。
import type { RouteRecordRaw } from 'vue-router';
import { mayorsCupRoutes } from './mayors-cup'

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Index.vue'),
        meta: {
            title: '首頁',
            description: '臺中市體育總會足球委員會官方網站：市長盃足球錦標賽賽程、即時比分與臺中足球最新消息。'
        }
    },
    ...mayorsCupRoutes,
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('@/views/NotFound.vue'),
        meta: {
            title: '很抱歉，頁面不存在!!',
            description: '您造訪的頁面不存在。'
        }
    }
];

export { routes };